<template>
    <div>
        <el-dialog class="invoice" :title="title" v-loading="isDialogLoading" :visible.sync="dialogVisible" width="50%"
            :close-on-click-modal="false" :before-close="cancelDialog">
            <el-form :model="ruleForm[invoiceIndex]" :rules="rules" ref="ruleForm" label-width="160px"
                class="invoice-rule">
                <el-row :gutter="20">
                    <el-row>
                        <el-col class="count-general" :span="24">共上传{{total}}张发票，成功{{succeedTolal}}张, 失败{{failTolal}}张
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row>
                        <el-col class="count-general" :span="24">{{invoiceIndex + 1}}/{{total}}</el-col>
                    </el-row>
                </el-row>
                <el-row :gutter="20">
                    <el-col>
                        <template>
                            <el-carousel :interval="4000" type="card" height="200px" :loop="false" :autoplay="false"
                                arrow="always" indicator-position="none" @change="changeInvoice">
                                <el-carousel-item v-for="(item,index) in invoiceLists" :key="index">
                                    <embed v-if="(/.pdf/).test(item.fileUrl)"  :src="item.fileUrl" type="application/pdf" width="100%" height="100%" />
                                    <el-image v-else style="width: 100%; height: 100%" :src="item.fileUrl"
                                        @click="changeUrl(item.fileUrl,index)">
                                        <p style="position: absolute; bottom: 0px; left: 0; background-color: white; opacity:0.9;display:none;text-align:left;border-radius:4px;"
                                            :class="item.fileId">
                                            {{index}}
                                        </p>
                                    </el-image>
                                </el-carousel-item>
                            </el-carousel>
                        </template>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-row>
                        <el-col :span="24">
                            <div class="message" :style="messageStyle(invoiceIndex)">{{ruleForm[invoiceIndex].code ===
                            '1' ? ruleForm[invoiceIndex].message : '上传成功'}}</div>
                        </el-col>
                    </el-row>
                </el-row>
                <el-divider></el-divider>
                <el-row :gutter="20">
                    <el-col :span="12" :gutter="20">
                        <el-form-item label="发票类型" prop="invoiceModel.ocrInvoiceType">
                            <el-select v-model="ruleForm[invoiceIndex].invoiceModel.ocrInvoiceType" placeholder="请输入发票类型"
                                style="width:100%" @change="invoiceTypeChange" :disabled="getisDisabled(invoiceIndex)">
                                <el-option v-for="item in formList" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 发票类型 1001：全电普票   0801：全电专票，非全电票发票代码必填，全电票不校验发票代码 -->
                        <el-form-item label="发票代码" prop="invoiceModel.invoiceCode"
                             :rules="(ruleForm[invoiceIndex].invoiceModel.ocrInvoiceType !== '1001' && ruleForm[invoiceIndex].invoiceModel.ocrInvoiceType !== '0801') ?
                                rules.invoiceModel.invoiceCode : [{ required: false}]">
                            <el-input v-model="ruleForm[invoiceIndex].invoiceModel.invoiceCode" maxlength="12"
                                placeholder="请输入发票代码" :disabled="getisDisabled(invoiceIndex) || invoiceCodeDisabled"></el-input>
                        </el-form-item>
                        <el-form-item label="发票号码" prop="invoiceModel.invoiceSerial">
                            <el-input v-model="ruleForm[invoiceIndex].invoiceModel.invoiceSerial" placeholder="请输入发票号码"
                                :disabled="getisDisabled(invoiceIndex)"></el-input>
                        </el-form-item>
                        <el-form-item label="开票日期" prop="invoiceModel.openInvoiceDate">
                            <el-date-picker :disabled="getisDisabled(invoiceIndex)"
                                popper-class="dispatch-center-car-scheduling"
                                v-model="ruleForm[invoiceIndex].invoiceModel.openInvoiceDate" type="date"
                                value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="验真状态" prop="name">
                            <el-input :value="isCheckedValue(ruleForm[invoiceIndex].invoiceModel.isChecked)"
                                placeholder="" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :gutter="20">
                        <el-form-item label="合计金额(不含税)" prop="invoiceModel.invoiceAmount">
                            <el-input v-model="ruleForm[invoiceIndex].invoiceModel.invoiceAmount" placeholder="请输入合计金额"
                                :disabled="getisDisabled(invoiceIndex)" @change="changeAmount"></el-input>
                        </el-form-item>
                        <el-form-item label="发票金额(含税)" prop="invoiceModel.amt">
                            <el-input v-model="ruleForm[invoiceIndex].invoiceModel.amt" placeholder="请输入发票金额"
                                :disabled="getisDisabled(invoiceIndex)" @change="changeAmount"></el-input>
                        </el-form-item>
                        <el-form-item label="纳税人识别号" prop="invoiceModel.taxNo">
                            <el-input v-model="ruleForm[invoiceIndex].invoiceModel.taxNo" placeholder="请输入纳税人识别号"
                                :disabled="getisDisabled(invoiceIndex)"></el-input>
                        </el-form-item>
                        <el-form-item label="购买方名称" prop="invoiceModel.buyerName">
                            <el-input v-model="ruleForm[invoiceIndex].invoiceModel.buyerName" placeholder="请输入购买方名称"
                                :disabled="getisDisabled(invoiceIndex)"></el-input>
                        </el-form-item>
                        <el-form-item label="校验码" prop="invoiceModel.checkCode" v-show='showCheck' :rules=" this.ruleForm[invoiceIndex].invoiceModel.ocrInvoiceType === '04'?[{
                            required: true,
                            message: '校验码不能为空',
                            trigger: ['blur', 'change']
                        },
                        { min: 6,  message: '长度必须大于6', trigger: ['blur', 'change'] }]:[                    {
                            required: false,
                            trigger: ['blur', 'change']
                        }]">
                            <el-input v-model="ruleForm[invoiceIndex].invoiceModel.checkCode" placeholder="请输入校验码"
                                :disabled="getisDisabled(invoiceIndex)"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer ad-dialog-footer">
                <el-button @click="saveInvoice" :disabled="getisDisabled(invoiceIndex)">保 存</el-button>
                <el-button @click="saveAllInvoice">批量保存</el-button>
            </div>
        </el-dialog>

        <Picture v-if="diaShaow" :data="rowData" :titlePicture="titlePicture" :imgUrl="imgUrl" :diaShaow="diaShaow"
            @handleStartClose="handleStartClose"></Picture>
    </div>
</template>

<script>
import { save } from '../../api/invoice';
import { onlyInputnumber } from '../judge/bmsModular';
import Picture from './Picture';
export default {
    components: { Picture },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        dataRow: {
            type: Object
        },
        title: {
            type: String
        },
        invoiceLists: {
            type: Array
        },
        requestParam: {
            type: Object,
            required: true
        },
        refreshInvoice: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            showCheck: false,
            ruleForm: [],
            invoiceIndex: 0,
            total: 0,
            succeedTolal: 0,
            failTolal: 0,
            orderObj: {},
            rules: {
                invoiceModel: {
                    ocrInvoiceType: [
                        {
                            required: true,
                            message: '发票类型不能为空',
                            trigger: ['blur', 'change']
                        }
                    ],
                    invoiceSerial: [
                        {
                            required: true,
                            message: '发票号码不能为空',
                            trigger: ['blur', 'change']
                        }
                    ],
                    invoiceCode: [
                        {
                            required: true,
                            message: '发票代码不能为空',
                            trigger: ['blur', 'change']
                        }
                    ],
                    openInvoiceDate: [
                        {
                            required: true,
                            message: '开票日期不能为空',
                            trigger: ['blur', 'change']
                        }
                    ],
                    invoiceAmount: [
                        {
                            required: true,
                            message: '合计金额不能为空',
                            trigger: ['blur', 'change']
                        }
                    ],
                    amt: [
                        {
                            required: true,
                            message: '发票金额不能为空',
                            trigger: ['blur', 'change']
                        }
                    ],
                    taxNo: [
                        {
                            required: true,
                            message: '纳税人识别号不能为空',
                            trigger: ['blur', 'change']
                        },
                        {
                            pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
                            message: '由18位数字或者大写字母组成，但是字母不包括 I、O、Z、S、V',
                            trigger: 'blur'
                        }
                    ],
                    buyerName: [
                        {
                            required: true,
                            message: '购买方名称不能为空',
                            trigger: ['blur', 'change']
                        }
                    ],
                    checkCode: [
                        {
                            required: true,
                            message: '校验码不能为空',
                            trigger: ['blur', 'change']
                        }
                    ]
                }
            },
            formList: [
                {
                    value: '01',
                    label: '增值税专用发票'
                },
                {
                    value: '04',
                    label: '增值税普通发票'
                },
                {
                    value: '08',
                    label: '增值税电子专用发票'
                },
                {
                    value: '10',
                    label: '增值税电子普通发票'
                },
                {
                    value: '1001',
                    label: '全电普票'
                },
                {
                    value: '0801',
                    label: '全电专票'
                }
            ],
            diaShaow: false,
            isDisabled: true,
            isDialogLoading: false,
            isReexamination: true,
            isDellLoading: false,
            isDell: true,
            isAgainLoading: false,
            rowData: {},
            imgUrl: '',
            url: '',
            titlePicture: '',
            requestParamObj: {},
            invoiceCodeDisabled: false
        };
    },
    methods: {
        getisDisabled(index) {
            var obj = this.ruleForm[index];
            if (obj.code === '0') {
                return true;
            } else if (obj.code === '1' && obj.fileUrl) {
                return false;
            } else {
                return true;
            }
        },
        isCheckedValue(isChecked) {
            return isChecked === '1' ? '验真成功' : isChecked === '0' ? '验真失败' : '未验真';
        },
        messageStyle(index) {
            var code = this.ruleForm[index].code;
            if (code === '1') {
                return {
                    color: 'red'
                };
            } else {
                return {
                    color: '#67C23A'
                };
            }
        },
        changeAmount() {
            if (!this.ruleForm.amt || !this.ruleForm.invoiceAmount) {
                return;
            }
            this.ruleForm.tax = (this.ruleForm.amt - this.ruleForm.invoiceAmount).toFixed(2);
            this.ruleForm.taxRate = (this.ruleForm.tax / this.ruleForm.invoiceAmount).toFixed(2);
        },
        invoiceTypeChange(val) {
            this.$nextTick(() => this.$refs.ruleForm.clearValidate());
            this.invoiceCodeDisabled = ['0801', '1001', '15', '16', '17'].includes(this.ruleForm[this.invoiceIndex].invoiceModel.ocrInvoiceType);
            this.invoiceCodeDisabled && (this.ruleForm[this.invoiceIndex].invoiceModel.invoiceCode = '');
            if (this.ruleForm[this.invoiceIndex].invoiceModel.ocrInvoiceType === '04' ||
                this.ruleForm[this.invoiceIndex].invoiceModel.ocrInvoiceType === '10') {
                this.showCheck = true;
            } else {
                this.showCheck = false;
            }
        },
        totalIpt(val) {
            this.ruleForm.invoiceAmount = onlyInputnumber(String(val));
        },
        cancelDialog() {
            this.$emit('clearCacheData');
            this.$emit('update:dialogVisible', false);
        },
        saveInvoice() {
            this.isDialogLoading = true;
            const flag = this.changeSaveInvoice(this.ruleForm[this.invoiceIndex]);
            if (flag) {
                var data = {};
                var invoiceSaveList = [];
                this.ruleForm[this.invoiceIndex].invoiceModel.invoiceNo =
                    this.ruleForm[this.invoiceIndex].invoiceModel.invoiceCode + this.ruleForm[this.invoiceIndex].invoiceModel.invoiceSerial;
                invoiceSaveList.push(this.ruleForm[this.invoiceIndex]);
                const item = invoiceSaveList[0];
                if (!item.invoiceModel.fee) {
                    invoiceSaveList[0].invoiceModel.fee = invoiceSaveList[0].invoiceModel.amt;
                    invoiceSaveList[0].invoiceModel.tax = (+invoiceSaveList[0].invoiceModel.amt - +invoiceSaveList[0].invoiceModel.invoiceAmount).toFixed(2);
                    invoiceSaveList[0].invoiceModel.taxRate = (+invoiceSaveList[0].invoiceModel.tax / +invoiceSaveList[0].invoiceModel.invoiceAmount).toFixed(2);
                }
                data.invoiceUploadResTOList = invoiceSaveList;
                data.params = this.requestParamObj;
                save(data).then(res => {
                    if (res.code === '0') {
                        if (res.data[0].code === '1') {
                            this.ruleForm[this.invoiceIndex].message = res.data[0].message;
                            this.$message.warning(res.data[0].message);
                        } else {
                            this.ruleForm[this.invoiceIndex] = res.data[0];
                            this.$message.success('保存成功');
                            this.countGeneral();
                            if (this.refreshInvoice) {
                                this.refreshInvoice();
                            }
                        }
                    } else {
                        this.$message.warning('操作失败');
                    }
                    this.isDialogLoading = false;
                });
                // 这里做保存的调用
            } else {
                this.isDialogLoading = false;
            }
        },
        checkFrom(item, index) {
            if (!item.invoiceModel.ocrInvoiceType) {
                this.$message.warning('第' + index + '张发票，发票类型不能为空');
                return false;
            }
            if (!item.invoiceModel.invoiceSerial) {
                this.$message.warning('第' + index + '张发票，发票号码不能为空');
                return false;
            }
            // 发票类型 1001：全电普票   0801：全电专票，非全电票要校验发票代码
            if (item.invoiceModel.ocrInvoiceType !== '1001' && item.invoiceModel.ocrInvoiceType !== '0801' &&
                !item.invoiceModel.invoiceCode) {
                this.$message.warning('第' + index + '张发票，发票代码不能为空');
                return false;
            }
            if (!item.invoiceModel.openInvoiceDate) {
                this.$message.warning('第' + index + '张发票，开票日期不能为空');
                return false;
            }
            if (!item.invoiceModel.invoiceAmount) {
                this.$message.warning('第' + index + '张发票，合计金额不能为空');
                return false;
            }
            if (!item.invoiceModel.amt) {
                this.$message.warning('第' + index + '张发票，发票金额不能为空');
                return false;
            }
            if (!item.invoiceModel.taxNo) {
                this.$message.warning('第' + index + '张发票，纳税人识别号不能为空');
                return false;
            }
            if (!item.invoiceModel.buyerName) {
                this.$message.warning('第' + index + '张发票，购买方名称不能为空');
                return false;
            }
            if ((item.invoiceModel.ocrInvoiceType === '04' || item.invoiceModel.ocrInvoiceType === '10') && !item.invoiceModel.checkCode) {
                this.$message.warning('第' + index + '张发票，校验码不能为空');
                return false;
            }
            return true;
        },
        changeSaveInvoice(item) {
            let validateFlag = false;
            if (item.isPdf === 'Y') {
                this.$message.warning('电子票必须为PDF格式,请检查');
                return false;
            }
            if (item.invoiceModel.invoiceAmount < 0 && item.invoiceModel.amt < 0) {
                if (parseFloat(item.invoiceModel.amt) > parseFloat(item.invoiceModel.invoiceAmount)) {
                    this.$message.warning('发票金额为负时，合计金额（不含税）必须大于等于发票金额（含税）');
                    return false;
                }
            }
            if (parseFloat(item.invoiceModel.invoiceAmount) > 0 && parseFloat(item.invoiceModel.amt) > 0) {
                if (parseFloat(item.invoiceModel.invoiceAmount) > parseFloat(item.invoiceModel.amt)) {
                    this.$message.warning('合计金额（不含税）必须小于等于发票金额（含税）');
                    return false;
                }
            }

            if (item.invoiceModel.invoiceAmount === '0') {
                this.$message.warning('合计金额(不含税)必须不等于0');
                return false;
            }
            if (item.invoiceModel.amt === '0') {
                this.$message.warning('发票金额（含税）必须不等于0');
                return false;
            }
            // 发票类型 1001：全电普票   0801：全电专票，全电票发票号码校验应为20位
            if ((item.invoiceModel.ocrInvoiceType === '1001' || item.invoiceModel.ocrInvoiceType === '0801') &&
                item.invoiceModel.invoiceSerial.length !== 20) {
                this.$message.warning('全电票发票号码应为20位，当前长度' + item.invoiceModel.invoiceSerial.length + '位，请检查');
                return false;
            }
            this.$refs.ruleForm.validate(valid => {
                validateFlag = valid;
            });
            return validateFlag;
        },
        saveAllInvoice() {
            this.isDialogLoading = true;
            // 数组遍历每项，然后检查
            let invoiceFlag = false;
            const invoiceSaveList = [];
            for (let i = 0; i < this.ruleForm.length; i++) {
                if (this.ruleForm[i].code === '1') {
                    if (!this.ruleForm[i].invoiceModel.taxNo) {
                        break;
                    }
                    if (!this.checkFrom(this.ruleForm[i], i + 1)) {
                        this.isDialogLoading = false;
                        return;
                    }
                    const flag = this.changeSaveInvoice(this.ruleForm[i]);
                    if (!flag) {
                        invoiceFlag = true;
                        break;
                    }
                    this.ruleForm[i].invoiceModel.invoiceNo =
                        this.ruleForm[i].invoiceModel.invoiceCode + this.ruleForm[i].invoiceModel.invoiceSerial;
                    var item = this.ruleForm[i];
                    if (!item.invoiceModel.fee) {
                        this.ruleForm[i].invoiceModel.fee = this.ruleForm[i].invoiceModel.amt;
                        this.ruleForm[i].invoiceModel.tax = (+this.ruleForm[i].invoiceModel.amt - +this.ruleForm[i].invoiceModel.invoiceAmount).toFixed(2);
                        this.ruleForm[i].invoiceModel.taxRate = (+this.ruleForm[i].invoiceModel.tax / +this.ruleForm[i].invoiceModel.invoiceAmount).toFixed(2);
                    }
                    invoiceSaveList.push(this.ruleForm[i]);
                }
            }
            if (invoiceFlag) {
                this.isDialogLoading = false;
                return;
            }
            if (invoiceSaveList.length === 0) {
                this.$message('没有需要保存的发票');
                this.isDialogLoading = false;
                return;
            }
            if (!invoiceFlag) {
                const data = {};
                data.invoiceUploadResTOList = invoiceSaveList;
                data.params = this.requestParamObj;
                save(data).then(res => {
                    if (res.code === '0') {
                        // this.total
                        let saveTotal = 0;
                        let saveSucTotal = 0;
                        let saveFalTotal = 0;
                        res.data.forEach(obj => {
                            saveTotal++;
                            if (obj.code === '1') {
                                // 可以使用vue的全局方法: this.$set()解决打破双向绑定的问题
                                this.ruleForm[this.orderObj[obj.fileId]].message = obj.message;
                                saveFalTotal++;
                            } else {
                                this.ruleForm[this.orderObj[obj.fileId]] = obj;
                                saveSucTotal++;
                            }
                        });
                        if (saveSucTotal > 0) {
                            this.countGeneral();
                            if (this.refreshInvoice) {
                                this.refreshInvoice();
                            }
                        }
                        this.$message.success('共保存' + saveTotal + '张发票，成功' + saveSucTotal + '张，失败' + saveFalTotal + '张');
                    } else {
                        this.$message.warning('操作失败');
                    }
                    this.isDialogLoading = false;
                });
            } else {
                this.isDialogLoading = false;
            }
        },
        handleDialog(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$emit('handleDialog', { state: true, data: this.ruleForm });
                } else {
                    this.$emit('handleDialog', { state: false, form: valid, data: {} });
                    return false;
                }
            });
        },
        previewBank() {
            this.titlePicture = '图片预览';
            this.imgUrl = this.url;
            this.diaShaow = true;
        },
        handleStartClose() {
            this.diaShaow = false;
        },
        // 新增
        changeUrl(url, index) {
            this.titlePicture = '图片预览';
            this.imgUrl = url;
            this.diaShaow = true;
            this.invoiceIndex = index;
        },
        changeInvoice(index) {
            this.invoiceIndex = index;
            this.invoiceTypeChange();
        },
        countGeneral() {
            this.total = this.ruleForm.length;
            this.succeedTolal = 0;
            this.failTolal = 0;
            let order = 0;
            this.ruleForm.forEach(obj => {
                this.orderObj[obj.fileId] = order;
                order++;
                if (obj.code === '0') {
                    this.succeedTolal++;
                } else {
                    this.failTolal++;
                }
            });
        }
    },
    mounted() {
        this.invoiceTypeChange();
        this.requestParamObj = this.requestParam;
    },
    watch: {
        invoiceLists: {
            deep: true,
            immediate: true,
            handler() {
                this.ruleForm = this.invoiceLists;
                this.countGeneral();
            }
        }
    }
};
</script>

<style lang="less">
@import "./InvoiceListDialog.less";
</style>
